import _ from "underscore";
import { MobileActions } from "../../store/mobile/actions";
import { IRawIoxData } from "../../services/ioxDataHandler";
import { getServerDate } from "../../utils/storage/date";
import { dispatcher, DispatcherEvents } from "../../utils/dispatcher";
import { IMobileStore } from "../../store/mobile/types";

import pageHTML from "./addin.tmpl";
import DebugPageView from "./debugPageView";

export default class AddInTest extends DebugPageView {
    private readonly template = _.template(pageHTML);
    private readonly testAddinApi = this.app.addinService.getAddinApi();

    private readonly newLog: IRawIoxData = {
        latitude: 43.64969,
        longitude: -79.6065,
        driverId: (<any> this.app.userService.getCurrentUser()).id,
        engineHours: 0,
        odometer: 0,
        rpm: 3000,
        roadSpeed: 30,
        tripDuration: 655,
        tripOdometer: 0,
        vehicleId: 20001010,
        dateTime: getServerDate().toISOString(),
        status: "GPS Valid | IGN on | Engine Data | Date/Time Valid | Speed From Engine | Distance From GPS | ",
        rawData: ""
    };

    constructor(options) {
        super(options);
        this.storeUnsubscribe = this.testAddinApi.mobile.listenTo(this.showGpsData.bind(this));
    }

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click #hashurl": this.navigate,
            "click #generateGpsData": this.generateGpsData
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    navigate(): void {
        let hashUrl = <HTMLInputElement> document.getElementById("hash");
        let hashUrlValue = hashUrl && hashUrl.value;
        let param = <HTMLInputElement> document.getElementById("param");
        let parameter = param && param.value;
        hashUrlValue && this.testAddinApi.mobile.navigate(hashUrlValue, parameter);
    }

    generateGpsData(): void {
        this.newLog.dateTime = getServerDate().toISOString();
        this.newLog.roadSpeed = 0;
        dispatcher.trigger(DispatcherEvents.NewIoxData, this.newLog, false);
    }

    showGpsData(mobileState: IMobileStore): void {
        let gpsData = mobileState.gpsData;
        if (gpsData) {
            let lat = <HTMLInputElement> document.getElementById("debug_latitude");
            if (lat) {
                lat.valueAsNumber = gpsData.latitude;
            }
            let long = <HTMLInputElement> document.getElementById("debug_longitude");
            if (long) {
                long.valueAsNumber = gpsData.longitude;
            }
            let source = <HTMLInputElement> document.getElementById("debug_source");
            if (source) {
                source.value = gpsData.source;
            }
        }
    }

    render() {
        this.el.innerHTML = this.template({});

        this.app.store.dispatch(MobileActions.setPageState({
            title: "AddIn",
            pageLevel: 2
        }));

        return this;
    }
}